import styled from 'styled-components';
import { Box } from '@interstate/components/Box';

export const TermsTab = styled.div`
    position: relative;

    hr {
        border-color: ${({ theme }) => theme.paymentTermsHrBorderColor};
    }
`;

export const StyledDealerDiscount = styled(Box)`
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 0.25rem;
    border: none;
    outline: none;
    background-color: inherit;
    color: #005ba8;
    & > * {
        pointer-events: none;
    }
    div {
        color: inherit;
    }
    &:focus-visible {
        outline: 2px solid #005ba8;
        outline-offset: 2px;
        border-radius: 2px;
    }
    &.disabled-button {
        cursor: not-allowed;
        color: #a0a0a0;
    }
`;

export const StyledDealerDiscountApplied = styled(Box)`
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
    border: none;
    outline: none;
    background-color: inherit;
    color: #07bc0c;
    & > * {
        pointer-events: none;
    }
    div {
        color: inherit;
    }
    &:focus-visible {
        outline: 2px solid #005ba8;
        outline-offset: 2px;
        border-radius: 2px;
    }
    &.disabled-button {
        cursor: not-allowed;
        color: #a0a0a0;
    }
`;

export const StyledDeferredAmountText = styled(Box)`
    cursor: default;
    user-select: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    border: none;
    outline: none;
    background-color: inherit;
    color: #07bc0c;
    padding-top: 0.5rem;
    div {
        color: inherit;
    }
`;
